// extracted by mini-css-extract-plugin
export default {"container":"style_container__e2evv","name":"style_name__q9AZu","description":"style_description__YdxTW"};